// User-defined attributes: the limits, in ONE place for the browser.
//
// The twin of twasta_runtime_engine/uda/limits.py (and Java UdaLimits). The
// values MUST stay equal; test-script/test_uda_model.py reads this file and
// compares every constant with the Python module, so a limit can never differ
// between the setup screen, the server and the runtime. Change a value here
// and in both twins in the same change. See limits.py for why each exists.

/** A form is decided by at most this many deciding columns. */
export const MAX_DRIVERS = 3
/** A deciding column may have at most this many distinct values. */
export const MAX_DRIVER_VALUES = 500
/** master-values asks for one more than the limit, so "more" is detectable. */
export const MASTER_VALUES_CAP = MAX_DRIVER_VALUES + 1
/** The largest page of rows the coverage grid asks for. */
export const GRID_ROW_PAGE = 200
/** The largest page of columns the coverage grid asks for. */
export const GRID_COL_PAGE = 50
/** The longest key (driver, set, column, flag) a layer may use. */
export const KEY_MAX_LENGTH = 40
/** The widest text value kept in the indexed `value_text` column. */
export const INDEXED_TEXT_MAX = 400
/** The setup screen's value picker searches its own list up to this many
 *  values; a longer one is searched by the server (master-values `q`). */
export const PICKER_LOCAL_MAX = 200
/** The Grid editor shows this many rows at a time ("Show more")… */
export const GRID_VIEW_ROW_STEP = 40
/** …and this many columns per column page. */
export const GRID_VIEW_COLS = 10
/** The longest source (characters) an organization's own function may have. */
export const CODE_SOURCE_MAX = 20000
/** The statement timeout (seconds) an organization's own SQL runs under. */
export const GUARDED_SQL_TIMEOUT_SECONDS = 10

export const UDA_LIMITS = {
  MAX_DRIVERS,
  MAX_DRIVER_VALUES,
  MASTER_VALUES_CAP,
  GRID_ROW_PAGE,
  GRID_COL_PAGE,
  KEY_MAX_LENGTH,
  INDEXED_TEXT_MAX,
  PICKER_LOCAL_MAX,
  GRID_VIEW_ROW_STEP,
  GRID_VIEW_COLS,
  CODE_SOURCE_MAX,
  GUARDED_SQL_TIMEOUT_SECONDS,
} as const
